import { AccordionSummary, TableRow } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
export const StyledTableRow = muiStyled(TableRow)(() => ({
  height: '1rem',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StyledAccordionSummary = muiStyled(AccordionSummary)(() => ({
  height: '48px',
  borderRadius: '4px',
}));
